import * as S from './FlightChangesCases.styles';
import { useTranslation } from '../../hooks/i18n';
import { Text } from '@hangar/web-components/core/Text';
import { Button } from '@hangar/web-components/core/Button';
import { flightChangesErrorStateUrl } from './flightChangesCasesPublicAssets';

export const FlightChangesCasesUnavailable = () => {
    const { t } = useTranslation();

    const handleReload = () => {
        globalThis.location.reload();
    };

    return (
        <S.UnavailableContainer data-testid="flight-cases-unavailable">
            <S.UnavailableIllustration
                src={flightChangesErrorStateUrl}
                alt=""
                width={136}
                height={136}
                decoding="async"
            />
            <Text variant="heading-sm" bold={true}>
                {t('flightChangesCases.errorMessage')}
            </Text>
            <Text variant="body-md" color="secondary">
                {t('flightChangesCases.errorMessageDescription')}
            </Text>
            <S.ReloadButton>
                <Button
                    variant="secondary"
                    label={t('flightChangesCases.reloadPage')}
                    onClick={handleReload}
                />
            </S.ReloadButton>
        </S.UnavailableContainer>
    );
};
